import { Injectable } from "@angular/core";
import { Adapter } from "src/app/core/adapter";

export class Consent {

    constructor(
        public sr:string,
        public key:string,
        public brand: string,
        public country:string,
        public language:string,
        public description:string

    ) {}
}

    @Injectable({
        providedIn: "root"
    })

    export class ConsentAdapter implements Adapter<Consent> {
        adapt(item:any): Consent {
            return new Consent(item.sr,item.consentKey,item.brand.brandName,item.country.countryName,item.language.description,item.consentText);
       }
    }

